
export default {
  data() {
    return {
      timer: null,
      timeMsg: '获取验证码',
      codeTime: 60,
      showTime: false
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    // 开启倒计时
    startTimer() {
      this.showTime = true
      const that = this
      this.timer = setInterval(() => {
        that.setTimer()
      }, 1000)
    },
    setTimer() {
      if (this.codeTime === 0) {
        this.cleartime()
        this.timeMsg = '重新获取验证码'
      }
      this.codeTime--
    },
    cleartime() {
      console.log('clearInterval')
      clearInterval(this.timer)
      this.timer = null
      this.showTime = false
      this.codeTime = 60
      this.timeMsg = '获取验证码'
    }
  }
}
